import Link from 'next/link';

import { RecentCommentModel } from '~types/recentComment';
import getTimeAgo from '~utils/date/getTimeAgo';

import {
  ArrowBox,
  CommentCompany,
  CommentDate,
  CommentName,
  CommentSubject,
  RecentCommentItemWrapper,
} from '../style';

function RecentCommentItem({
  id,
  companyName,
  subject,
  name,
  commentsCount,
  createdAt,
}: RecentCommentModel) {
  return (
    <Link href={`/board/${id}`}>
      <RecentCommentItemWrapper
        data-attribute-id='home__board__click'
        data-content-id={id}
        data-company-name={companyName}>
        <>
          <CommentCompany>{companyName}</CommentCompany>
          <CommentSubject>
            <p>{subject}</p>
            {commentsCount > 0 && (
              <ArrowBox>
                {commentsCount}
                <div className='arrow'></div>
              </ArrowBox>
            )}
          </CommentSubject>
          <CommentName>{name}</CommentName>
          <CommentDate>{getTimeAgo(createdAt)}</CommentDate>
        </>
      </RecentCommentItemWrapper>
    </Link>
  );
}

export default RecentCommentItem;
